import {ReportEmployeeLocationHistoryModel} from "../../models/reports/ReportEmployeeLocationHistoryModel";

export class ReportEmployeeLocationHistoryCtrl {
    public static $inject = ['$scope','ReportEmployeeLocationHistoryModel'];
    constructor(public $scope: any, public model: ReportEmployeeLocationHistoryModel) {
        $scope.vm = this;
        this.$scope.$watch(() => [this.model.location, this.model.firstName, this.model.lastName, this.model.email], (newValue: string, oldValue: string) => {
            this.model.getCount();
        },true);
    }
}
